import Axios from "../Config/API";
import {
    IFiltrouserDashboard,
    IModulosUsuario,
    IUserDashboard,
    RegisterUserInterface,
} from "../../Interfaces/Users/UsersInterface";
import { IUserInfor } from "../../Context/User";
import Service from "./../Service";

export async function RegisterService(
    props: RegisterUserInterface,
    idUsuarioCopia?: number
) {
    return Service(
        Axios.post(
            `/home/users/register?idUsuarioCopia=${idUsuarioCopia}`,
            props
        )
    );
}

export async function AtualizarAsssinaturaUsuarioService(
    requestBody: FormData,
    idUsuario?: number
) {
    return Service(
        Axios.put(
            `/home/users/atualizarassinaturausuario?idUsuario=${idUsuario}`,
            requestBody
        )
    );
}

export async function CadastrarFotoUsuarioService(
    requestBody: FormData,
    idUsuario?: number
) {
    return Service(
        Axios.put(
            `/home/users/cadastrarfotousuario?idUsuario=${idUsuario}`,
            requestBody
        )
    );
}

export async function ListarModulosdoUsuarioService() {
    return Service(
        Axios.get<Array<IModulosUsuario>>(`/home/users/listarmodulosdousuario`)
    );
}

export async function GetUserInforServices() {
    return Service(Axios.get<IUserInfor>(`/home/users/getusuario`));
}

export async function ListarusuariosdashboardService(
    filtros: IFiltrouserDashboard
) {
    return Service(
        Axios.post<Array<IUserDashboard>>(
            `/home/users/listarusuariosdashboard`,
            filtros
        )
    );
}
